module.exports = __webpack_public_path__ + "img/cancel.d3e110f6.png";